export const ROLE_PERMISSIONS = {
  superadmin: [
    "superadmin:view",
    "organizations:manage",
    "branches:manage",
    "cameras:manage",
    "alerts:manage",
    "alerts:ack",
    "alerts:resolve",
    "clips:view",
    "ai_config:manage",
    "users:manage",
    "audit:view",
    "health:view",
    "onboarding:manage",
    "reports:view",
    "billing:manage",
  ],
  owner: [
    "branches:manage",
    "cameras:manage",
    "alerts:manage",
    "alerts:ack",
    "alerts:resolve",
    "clips:view",
    "ai_config:manage",
    "users:manage",
    "audit:view",
    "health:view",
    "onboarding:manage",
    "reports:view",
    "billing:manage",
  ],
  admin: [
    "branches:manage",
    "cameras:manage",
    "alerts:manage",
    "alerts:ack",
    "alerts:resolve",
    "clips:view",
    "ai_config:manage",
    "users:manage",
    "audit:view",
    "health:view",
    "onboarding:manage",
    "reports:view",
    "billing:manage",
  ],
  auditor: ["branches:view", "cameras:view", "alerts:view", "clips:view", "audit:view", "health:view", "reports:view"],
  vigilante: ["cameras:view", "alerts:view", "alerts:ack", "health:view"],
};

export const normalizeRole = (role) => {
  const value = String(role || "vigilante").toLowerCase();
  if (value === "client_admin" || value === "client-admin") return "admin";
  if (value === "client_user" || value === "client-user") return "vigilante";
  if (ROLE_PERMISSIONS[value]) return value;
  if (value === "cliente" || value === "viewer") return "admin";
  return "vigilante";
};

export const hasPermission = (role, permission) => {
  const normalized = normalizeRole(role);
  const permissions = ROLE_PERMISSIONS[normalized] || [];
  if (permissions.includes(permission)) return true;
  if (permission.endsWith(":view")) return permissions.includes(permission.replace(":view", ":manage"));
  return false;
};

export const hasAnyPermission = (role, permissions) => permissions.some((permission) => hasPermission(role, permission));
